"use client"

import { SquarePercent } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `SquarePercentIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const SquarePercentIcon = component(Icon)({ as: SquarePercent })
